import React, { Component } from 'react';
import { Form, InputNumber, Modal } from 'antd';

class Demo extends Component {
  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.props.handleSet(values);
      }
    });
  };

  checkPrice = (rule, value, callback) => {
    if (value.number > 0) {
      callback();
      return;
    }
    callback('Price must greater than zero!');
  };

  render() {
    const {
      form: { getFieldDecorator },
      config,
    } = this.props;
    return (
      <Modal
        visible
        title="工位设置"
        onCancel={this.props.onCancel}
        width={300}
        onOk={this.handleSubmit}
      >
        <Form>
          <Form.Item label="每行工位数">
            {getFieldDecorator('lineNum', {
              initialValue: config.lineNum,
            })(<InputNumber min={1} precision={0} />)}
            <span style={{ paddingLeft: '5px' }}>个</span>
          </Form.Item>
          <Form.Item label="工位月租单价">
            {getFieldDecorator('unit', {
              initialValue: config.unit,
            })(<InputNumber precision={2} />)}
            <span style={{ paddingLeft: '5px' }}>元（默认值）</span>
          </Form.Item>
        </Form>
      </Modal>
    );
  }
}

export default Form.create({ wrappedComponentRef: true })(Demo);



// WEBPACK FOOTER //
// ./src/components/incubator/seat/SeatSet.js